import React, { useContext, useEffect } from 'react';
import RefsContext from '../../contexts/RefsContext';
import { styleNotAllowed } from '../../utils/styleUtils';

function ListaLayers({ featureLayers, idLayerSeleccionado, handleCambioLayer, disabled, esWidgetCerca = false }) {
    const { expandsWidgetsButtonsRef } = useContext(RefsContext);
    const { widget } = expandsWidgetsButtonsRef.current.expands.cerca;

    useEffect(() => {
        if (esWidgetCerca){
            widget.idLayerSeleccionado = idLayerSeleccionado;
        }
    }, [widget, idLayerSeleccionado, esWidgetCerca]);

    function handleChange(e){
        handleCambioLayer(e.target.value);
    }

    return (
        <select className='esri-select' value={idLayerSeleccionado} onChange={handleChange} disabled={disabled ? true : null} style={styleNotAllowed(disabled)}>
            {
                featureLayers.map(featureLayer =>
                    <option key={featureLayer.id} value={featureLayer.id}>{featureLayer.title}</option>
                )
            }
        </select>
    );
}

export default ListaLayers;